(function () {
  function convertNofollowLinks() {
    document.querySelectorAll('.rebuy-widget a[rel*="nofollow"], [data-rebuy-id] a[rel*="nofollow"]').forEach(function (link) {
      link.setAttribute('rel', 'dofollow');
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.classList?.contains('rebuy-widget') || node.hasAttribute?.('data-rebuy-id'))) {
            setTimeout(convertNofollowLinks, 100);
          }
        });
      }
    });
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });
})();
